import { IController } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { IStudent } from '../../../../../../../../ng2/shared/typings/interfaces/student.interface';
import { IGraduationDate } from './../../../../../../../../ng2/shared/constants/graduation-date.constant';
// tslint:disable-next-line:max-line-length
import {
  CreditGapsPriorityGroupingsTransferService,
  IPriorityGroupDefinition,
} from './../../../../../../../shared/services/credit-gaps-priority-groupings/credit-gaps-priority-groupings-transfer.service';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

interface IStudentIdsByGapsCollection {
  unaddressedGaps: { students: any[]; studentIds: string[] };
  pendingGapsResolutions: { students: any[]; studentIds: string[] };
  noGaps: { students: any[]; studentIds: string[] };
}

interface IExtendedPriorityGroupDef extends IPriorityGroupDefinition {
  studentIds: string[];
}

export class CreditGapsStepCtrl implements IController {
  static $inject: string[] = [
    '$scope',
    'ImSchool',
    'ObjectCache',
    'CreditGapsPriorityGroupingsTransferService',
    'WizardUtils',
  ];

  public studentsByCreditGaps: IStudentIdsByGapsCollection;
  public unflattenedStudents: IStudent[];
  public filteredStudents: any[]; // sdc students
  public priorityGroupFilter: string;
  public priorityGroupTable: IExtendedPriorityGroupDef[];
  private studentsWithUnaddressedGaps: any[]; // sdc students
  private sort: string;
  public options: IWizardFilterActionsOptions;

  // bindings
  public selectedGradDate: string | null;
  public courseDiffs;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private ObjectCache,
    private CreditGapsPriorityGroupingsTransferService: CreditGapsPriorityGroupingsTransferService,
    private WizardUtils: WizardUtils,
  ) {
    this.options = { columnKeys: ['gradPlan', 'creditMaxGaps', 'creditMaxGapsNoPlan'] };
  }

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    const gradDateFilter: string[] | null = this.WizardUtils.getCurrentPlannedGradDateFilter();
    const lastGradDate: IGraduationDate = _.last(this.ImSchool.getNextFourGradDatesForTransfer());
    const lastGradDateHumanName: string = lastGradDate.humanName;
    // `beyond ${lastTerm}` date requires filter customization
    //  see`creditGapsPriorityGroupingsTransfer` service
    if (gradDateFilter) {
      this.priorityGroupFilter =
        gradDateFilter.length === 1 ? gradDateFilter.toString() : `Beyond ${lastGradDateHumanName}`;
    } else this.priorityGroupFilter = null;

    this.unflattenedStudents = this.WizardUtils.getFilteredUnflattenedStudents();
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.studentsByCreditGaps = this.getStudentsByCreditGaps(this.filteredStudents);
    this.studentsWithUnaddressedGaps = this.studentsByCreditGaps.unaddressedGaps.students;
    this.sort = this.ObjectCache.cacheObject([{ colId: 'creditMaxGapsNoPlan', sort: 'desc' }]);
    this.priorityGroupTable = this.buildPriorityGroupTable(this.studentsWithUnaddressedGaps);
  }

  private getStudentsByCreditGaps(students): IStudentIdsByGapsCollection {
    const baseObj = {
      unaddressedGaps: { students: [], studentIds: [] },
      pendingGapsResolutions: { students: [], studentIds: [] },
      noGaps: { students: [], studentIds: [] },
    };
    return _.reduce(
      students,
      (result, student: any) => {
        const { studentId, creditMaxGapsNoPlan, creditMaxGaps } = student;
        const unaddressedGaps = creditMaxGapsNoPlan < 0;
        const pendingGapsResolutions = creditMaxGaps < 0 && creditMaxGapsNoPlan >= 0;
        const noGaps = creditMaxGaps === 0;
        if (unaddressedGaps) {
          result.unaddressedGaps.students.push(student);
          result.unaddressedGaps.studentIds.push(studentId);
        } else if (pendingGapsResolutions) {
          result.pendingGapsResolutions.students.push(student);
          result.pendingGapsResolutions.studentIds.push(studentId);
        } else if (noGaps) {
          result.noGaps.students.push(student);
          result.noGaps.studentIds.push(studentId);
        }
        return result;
      },
      baseObj,
    );
  }

  private getPriorityGroupByGradDate(priorityGroupFilter) {
    return this.CreditGapsPriorityGroupingsTransferService.getPriorityGroupsByPlannedGradDateFilter(
      priorityGroupFilter,
    );
  }

  private buildPriorityGroupTable(students): IExtendedPriorityGroupDef[] {
    const priorityGroupings = this.getPriorityGroupByGradDate(this.priorityGroupFilter);
    const priorityGroupingsWithAppendedField = _.map(priorityGroupings, (group: any) => {
      group.studentIds = [];
      return group;
    });
    _.each(students, (student: any) => {
      const { creditGapPriorityGrouping, studentId } = student;
      const matchedPriorityGroup = _.find(priorityGroupingsWithAppendedField, {
        studentPriorityGroupingValue: creditGapPriorityGrouping,
      });
      matchedPriorityGroup.studentIds.push(studentId);
    });
    return priorityGroupingsWithAppendedField;
  }
}
